import { TErrorNotification } from '@/components/ErrorInlineNotification/ErrorInlineNotification';
import { usePostApiJsApPayeesInvitationsMails } from '@/context/services/doc_instructions/DocInstructions.service';
import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import {
  PostApiJsApPayeesInvitationsMailsBody,
  SearchedApPayee,
} from 'ap-openapi';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const useSendMails = (
  payeeList: SearchedApPayee[],
  setError?: TErrorNotification['setError']
) => {
  const { mutateAsync, isPending } = usePostApiJsApPayeesInvitationsMails();
  const formMethods = useFormContext<InstructionEmailForm>();
  const { t } = useTranslation();

  const onSendMails = useCallback(
    async (onSuccess?: () => void) => {
      const formValues = formMethods.getValues();
      const payload: PostApiJsApPayeesInvitationsMailsBody = {
        ap_payee_ids: payeeList.map((payee) => String(payee.id)),
        body: formValues.content,
        subject: formValues.subject,
        save_as_template: formValues.saveAsTemplate,
      };
      try {
        const { errors, status } = await mutateAsync({ data: payload });
        if (status === 'success') {
          onSuccess?.();
          return;
        }
        if (status === 'error' && errors?.messages && setError) {
          setError(new Error(errors.messages.join('')));
          return;
        }
      } catch (error) {
        if (error instanceof Error) {
          setError?.(error);
        } else {
          setError?.(new Error(t('system_error')));
        }
      }
    },
    [mutateAsync, setError, t, formMethods, payeeList]
  );

  return { onSendMails, isPending };
};
